import Model from "./Model";

export default class extends Model {
    constructor(urls) {
        super(urls);
        this.urls.route_admin_groups = urls.route_admin_groups;
    }

    async loadTable(page, limit, search = '') {
        let response = await super.list(page, limit, search).then(result => {return result});
        let result = {
            tbody: [],
            pages: response.pages,
        };
        if(response.items !== undefined && response.items.length > 0)
        {
            response.items.forEach(admin => {
                let telem = {
                    tbody: {},
                    data: {}
                };
                telem.id = admin.id;
                telem.tbody.email = admin.email;
                telem.tbody.role = admin.group.name;
                telem.data.group_name = admin.group.name;
                result.tbody.push(telem);
            });
        }
        return result;
    }

    async getAdminGroups() {
        if(this.urls.route_admin_groups === undefined)
        {
            console.log('error: route_admin_groups_undefined');
            return false;
        }
        return await axios.get(this.urls.route_admin_groups).then(response => {
            if(response.data.status === 'ok')
            {
                return {
                    items: response.data.items
                };
            }
            return false;
        });
    }
}
